function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgHammer = function SvgHammer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#386895"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#273B7A"
    },
    d: "M504.52,317.604L308.079,120.492l-16.789,16.029l-7.58-5.665l-7.647,15.836l-5.13,3.582l2.293,2.293 l-11.907,15.675l46.561,46.559L124.721,408.731l101.54,101.54C236.018,511.4,245.939,512,256,512 C376.144,512,476.941,429.228,504.52,317.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M304.03,130.203c0,0-1.784,11.467,14.272,17.329c16.055,5.861,46.637,21.152,60.909,71.611 c14.272,50.459,14.017,62.947,14.017,62.947l-23.426-0.359c0,0-14.272-56.067-34.028-43.86 c-16.137,9.971-37.604,26.124-37.604,26.124l-28.712-28.713c0,0,18.928-27.289,23.799-39.991 c3.213-8.378,7.718-27.884-24.648-29.667L304.03,130.203z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M379.209,219.145c-5.454-19.287-13.295-33.423-21.794-43.872l-73.985,73.985l14.739,14.739 c0,0,21.466-16.153,37.604-26.124c19.756-12.207,34.028,43.86,34.028,43.86l23.426,0.359 C393.225,282.091,393.48,269.603,379.209,219.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M261.075,168.289l-21.466-21.466c-2.798-2.798-2.798-7.335,0-10.135l37.267-37.267 c2.798-2.798,7.335-2.798,10.135,0l21.466,21.466c2.798,2.798,2.798,7.335,0,10.135l-37.267,37.267 C268.41,171.087,263.873,171.087,261.075,168.289z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7F4F"
    },
    d: "M124.721,408.731L124.721,408.731c7.928,7.928,20.783,7.928,28.712,0l144.734-144.734l-28.712-28.713 L124.721,380.018C116.793,387.948,116.793,400.803,124.721,408.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D35933"
    },
    d: "M124.357,408.329c0.126,0.131,0.234,0.272,0.364,0.402l0,0c7.928,7.928,20.783,7.928,28.712,0 l144.734-144.734l-14.739-14.739L124.357,408.329z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHammer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hammer.58b0bfcd.svg";
export { ForwardRef as ReactComponent };